import { string, bool } from "prop-types"
import { useRegistration } from "source/registrations/hooks/useRegistration"
import { AlertMessage } from "source/shared/AlertMessage"
import { NarrowLayout } from "source/shared/Layout"
import Notification from "./Notification"
import Header from "./Header"
import Alert from "./Alert"
import AttendeeSelections from "./AttendeeSelections"
import RegistrantQuestions from "./RegistrantQuestions"
import Help from "./Help"

const REGISTRATION_INCLUDES = [
  "attendees.attendee_type",
  "attendees.person",
  "responsible_person",
  "event.questions",
  "event.contact",
  "event.event_times",
  "answers",
]

const AuthenticatedConfirmation = ({
  registrationId,
  isNotificationShowing = false,
}) => {
  const { errors, data: registration } = useRegistration(registrationId, {
    include: REGISTRATION_INCLUDES,
  })

  if (errors) {
    return <AlertMessage>{errors[0].detail}</AlertMessage>
  }

  return (
    <NarrowLayout>
      {isNotificationShowing && (
        <Notification email={registration.responsiblePerson.emailAddress} />
      )}
      <Header registration={registration} />
      <Alert registration={registration} />
      <AttendeeSelections registration={registration} />
      {registration.questions.length > 0 && (
        <RegistrantQuestions registration={registration} />
      )}
      <Help registration={registration} />
    </NarrowLayout>
  )
}

AuthenticatedConfirmation.propTypes = {
  registrationId: string,
  isNotificationShowing: bool,
}

export default AuthenticatedConfirmation
